import { isNative } from 'lodash';

export default [
	{
		name: 'View Current/Past Shoots',
		path: '/view/shoots',
		component: () => import('../views/public_landing/ShootList.vue'),
		meta: {
			lander: !isNative(),
			public: true,
			imageBackground: true,
		},
	},
	{
		name: 'View Scores',
		path: '/view/club/:clubId/shoot/:shootId/scores',
		component: () => import('../views/ShootViewer/ViewScores.vue'),
		meta: {
			lander: !isNative(),
			public: true,
			imageBackground: true,
		},
	},
	{
		name: 'View Winners',
		path: '/view/club/:clubId/shoot/:shootId/event-winners',
		component: () => import('../views/ShootViewer/ViewShootOffs.vue'),
		meta: {
			lander: !isNative(),
			public: true,
			imageBackground: true,
		},
	},
];
